import React, { Component } from "react";
import styled from "styled-components";
import arrows from './arrows.png'


const BottomFixedWrapper = styled.div`
  display:none;
  position:fixed;
  bottom:0px;
  z-index:2;
  overflow-x: scroll;
  width:auto;
  white-space: nowrap;
  
  background:#f6f6f6;
  @media (max-width:767px) {
    display:block;
  }
 
`
const CarouselWrapper = styled.div`
   display:none;
  height: auto!important;
  position:fixed;
  width:100%;
  background:#f6f6f6;
  z-index:2;

  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  bottom:0px;
  left:0px;
  @media (max-width:767px) {
    display:block;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

const NavigationsWrappers = styled.a`
  position: fixed;
  z-index: 42;
  width: 20px;
  bottom:0;
  height: 70px;
  opacity: .5;
  text-align: center;
  -webkit-transition: all linear .1s;
  transition: all linear .1s;
  background: #000;
  cursor: pointer;
  &::before{
    content: "";
    position: absolute;
    top: 50%;
    margin-top: -17px;
  }
`
const LeftNav = styled(NavigationsWrappers)`
  left:0px;
  &::before{
    background-position: 0 0;
    background-repeat: no-repeat;
    overflow: hidden;
    display: block;
    width: 7px;
    height: 35px;
    background-image: url("/images/arrows.png");
    left: 50%;
    margin-left: -6px;
  }
`
const RightNav = styled(NavigationsWrappers)`
  right:0px;
  &::before{
    background-position: -82px 0;
    background-repeat: no-repeat;
    overflow: hidden;
    display: block;
    width: 7px;
    height: 37px;
    background-image: url("/images/arrows.png");
    right: 6px;
  }
`

class MobileCarousel extends Component { 

  constructor(props){
    super(props);
    this.scrollbleElement = React.createRef();
  }
  componentDidMount(){
    let lastX = localStorage.getItem('lastX');
    let lastScrollLeftPosition = localStorage.getItem('lastScrollLeftPosition');
    if(lastX && lastScrollLeftPosition){
      lastX = parseInt(lastX);
      lastScrollLeftPosition  = parseInt(lastScrollLeftPosition);
      let width = window.innerWidth;
      let center = width/2;
      let difference =lastX - center;
      this.scrollbleElement.current.scrollBy({
        left: lastScrollLeftPosition+difference
      });
    }
  }

  ScrollLeft(e){
    // console.log(e);
    let targetElement =  e.srcElement || e.target ;
    let scrollbleElement = targetElement.parentElement.parentElement;
     scrollbleElement.scrollBy({
      top: 0,
      left: -300,
      behavior: 'smooth'
    });
  }
  ScrollRight(e){
    let targetElement =  e.srcElement || e.target ;
    let scrollbleElement = targetElement.parentElement.parentElement;
    scrollbleElement.scrollBy({
      top: 0, // could be negative value
      left: 300,
      behavior: 'smooth'
    });
  }


  render(){
    return <>
    <CarouselWrapper  id='mobile-scroller' ref={this.scrollbleElement}>
        <div>
          <LeftNav onClick={this.ScrollLeft}></LeftNav>
          <RightNav onClick={this.ScrollRight}></RightNav>
          <div style={{padding:'0px 20px'}}>
            {this.props.children}
          </div>
        </div>
      </CarouselWrapper>  
    </>
  }
}

export default MobileCarousel;